import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Loader2 } from "lucide-react";
import SoulumoFooter from "../../components/SoulumoFooter";
import { LaunchBanner } from "../../components/soulumoLaunch/LaunchBanner";
import { S, SANS } from "../SoulumoLaunch/slUi";
import { Problem, Cue } from "../SoulumoLaunch/slOpen";
import { HeroC } from "../SoulumoLaunch/slHeroes";
import { Areas } from "../SoulumoLaunch/slAreas";
import { Different } from "../SoulumoLaunch/slDifferent";
import { Layers } from "../SoulumoLaunch/slLayers";
import { Personal, Night, DayNight } from "../SoulumoLaunch/slStory";
import { Together } from "../SoulumoLaunch/slTogether";
import { Coaches } from "../SoulumoLaunch/slCoaches";
import { Foundations, Steps, Price, Close } from "../SoulumoLaunch/slEnd";

const API = process.env.REACT_APP_BACKEND_URL;

const StickyCta = () => {
  const nav = useNavigate();
  const [show, setShow] = useState(false);
  useEffect(() => {
    const on = () => setShow(window.scrollY > window.innerHeight * 0.9);
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.div initial={{ y: 90, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 90, opacity: 0 }} transition={{ duration: 0.4 }}
          className="sm:hidden fixed bottom-0 inset-x-0 z-[120] px-4 pt-3" style={{ paddingBottom: "max(14px, env(safe-area-inset-bottom))", background: "linear-gradient(180deg, transparent, rgba(7,13,29,0.92) 40%)" }}>
          <button type="button" onClick={() => nav("/soulumo/demo?from=launch")} data-testid="sl-sticky-cta" className="w-full min-h-[54px] rounded-full uppercase active:scale-[0.98] transition-transform duration-200"
            style={{ background: S.gold, color: S.night, fontFamily: SANS, fontSize: "0.7rem", letterSpacing: "0.24em", fontWeight: 600 }}>Experience Soulumo</button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

// Soulumo launch page: the Golf/Gym template, told through layers and journeys.
export default function SoulumoLaunchPage() {
  const [g, setG] = useState(null);
  useEffect(() => {
    document.title = "Soulumo · Change the conversation you have with yourself";
    axios.get(`${API}/api/soulumo-launch/content`).then((r) => setG(r.data.guide)).catch(() => setG(false));
  }, []);
  if (g === null) return <div className="min-h-screen flex items-center justify-center" style={{ background: S.night }}><Loader2 className="animate-spin" color={S.gold} /></div>;
  if (g === false) return <div className="min-h-screen flex items-center justify-center px-6 text-center" style={{ background: S.night, color: S.cream, fontFamily: SANS }}>Please refresh in a moment.</div>;
  return (
    <main className="gp-root min-h-screen overflow-x-hidden" style={{ background: S.night }} data-testid="soulumo-launch-page">
      <LaunchBanner closable={false} flush />
      <HeroC g={g} testId="sl-hero" />
      <Problem g={g} />
      <Cue text="Tell me what you'd like to work on. I'll help you from there." testId="sl-cue-adelaida" />
      <Areas />
      <Different />
      <Layers />
      <Personal />
      <Night />
      <DayNight />
      <Together />
      <Coaches />
      <Cue text="Not sure where to begin? Start with something ready-made." tone="sand" testId="sl-cue-foundations" />
      <Foundations />
      <Steps />
      <Price />
      <Close g={g} />
      <div className="pb-24 sm:pb-0"><SoulumoFooter /></div>
      <StickyCta />
    </main>
  );
}
